import { createSlice } from '@reduxjs/toolkit'
import { DepttsLogin } from '../services/DepttUser';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const initialState = {

    errorMessage: "",
    sucessfullMessage: "",
    loader: false,
    sucessfull: false,
    isError: false,
    token: "",
    userdetail: "",
    loginSuccessfull: false
}

const AuthSlice = createSlice({
    name: "ApplicantsUser",
    initialState,
    reducers: {
        clearState: (state, action) => {
            // Object.assign(state, action.payload)
            return initialState
        },
    },
    extraReducers: {


        // this is login portion

        [DepttsLogin.fulfilled]: (state, action) => {
            state.loader = false

            if (action.payload === undefined) {
                toast.error('Server down')
                // console.log('undefined')
            }

            else if (action.payload.error) {
                state.isError = true
                state.errorMessage = action.payload.error
                // toast(action.payload.error)
                // console.log("payload error", action.payload.error)
            }
            else if (action.payload.message) {
                state.loginSuccessfull = true
                state.token = action.payload.token
                state.userdetail = action.payload.depttUser
                state.sucessfullMessage = action.payload.message
                // console.log(action.payload, "this is action paylaod")
                // toast.success("successfull login")
            }
            else {

                toast.error('internet issue')
            }
        },

        [DepttsLogin.pending]: (state) => {
            state.loader = true;
        },

    }

});



export const { clearState } = AuthSlice.actions



export default AuthSlice.reducer